import { useMemo } from 'react';
import { pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';

import * as helpers from '../helpers';
import { DEFAULT_VALUE_FOR_HIDE_FROM_USER_TYPES } from '../constants';

export const useDefaultValues = ({ fields }) => {
    const { allowedCurrencies, allowedCountries } = useAppSelector(pick([
        'allowedCurrencies', 'allowedCountries'
    ]));

    return useMemo(() => fields
        .filter((field) => (field.imsField || field.usePlayerTags || field.isNoIMSField) && field.defaultValue
            && (field.hideFromUser || !DEFAULT_VALUE_FOR_HIDE_FROM_USER_TYPES.includes(field.type))
            || field.type === FORM_FIELD_TYPE.CHECKBOX
            || field.type === FORM_FIELD_TYPE.DROPDOWN
            || field.type === FORM_FIELD_TYPE.RADIO_BUTTON)
        .reduce((accumulator, field) => {
            let value;

            switch (field.type) {
                case FORM_FIELD_TYPE.RADIO_BUTTON:
                    value = helpers.imsToFieldValue(field.defaultValue, field);
                    break;
                case FORM_FIELD_TYPE.DROPDOWN:
                    value = helpers.imsToFieldValue(field.defaultValue, field, { allowedCurrencies, allowedCountries });
                    break;
                default: value = field.defaultValue;
            }

            return {
                ...accumulator,
                [field.name]: value
            };
        }, {}), [fields, allowedCurrencies, allowedCountries]);
};
